module.exports = __webpack_public_path__ + "static/rewards-card-boost-167a64d1380167c2b28e74c2b9891cb5.png";